import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import styles from './InterestRateMessage.module.css';
type TProps = {
  className?: string;
};

export const InterestRateMessage = ({ className }: TProps) => {
  return (
    <p className={clsx(styles.message, className)}>
      *{' '}
      <Trans>
        Please be aware that interest is charged on a daily basis on your
        client's outstanding balance. Monthly repayment dates and interest
        payments may vary.
      </Trans>
    </p>
  );
};
